import { Building2, Home as HomeIcon, Crown, Utensils, Palette, Camera, Mic, Music, Layers } from "lucide-react";

/**
 * Single source of truth for listing categories.
 * kind: "venue"  -> has guest capacity, cuisine
 *       "food"   -> caterers: per-plate price, cuisine, parallel events
 *       "service"-> people/studios: no capacity, no cuisine, price "per event"
 */
export const CATEGORIES = [
  { key: "banquet_hall", label: "Banquet Hall", plural: "Banquet halls", short: "Banquet halls", kind: "venue", Icon: Building2,
    img: "https://images.pexels.com/photos/33852468/pexels-photo-33852468.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
    blurb: "Indoor halls & kalyana mantapas" },
  { key: "lawn", label: "Wedding Lawn", plural: "Wedding lawns", short: "Lawns", kind: "venue", Icon: HomeIcon,
    img: "https://images.pexels.com/photos/37331160/pexels-photo-37331160.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
    blurb: "Open lawns, farmhouses & resorts" },
  { key: "hotel_banquet", label: "Hotel Banquet", plural: "Hotel banquets", short: "Hotels", kind: "venue", Icon: Crown,
    img: "https://images.unsplash.com/photo-1708606811579-23b18fc48007?crop=entropy&cs=srgb&fm=jpg&w=940",
    blurb: "Ballrooms with rooms for guests" },
  { key: "catering", label: "Caterer", plural: "Caterers", short: "Catering", kind: "food", Icon: Utensils,
    img: "https://images.pexels.com/photos/36766881/pexels-photo-36766881.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
    blurb: "Menus, live counters & service staff" },
  { key: "decoration", label: "Decorator", plural: "Decorators", short: "Decor", kind: "service", Icon: Palette,
    img: "https://images.pexels.com/photos/12688995/pexels-photo-12688995.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
    blurb: "Mandaps, florals & lighting" },
  { key: "photography", label: "Photographer", plural: "Photographers", short: "Photography", kind: "service", Icon: Camera,
    img: "https://images.unsplash.com/photo-1519741497674-611481863552?w=940&q=70",
    blurb: "Candid, traditional & wedding films" },
  { key: "anchor", label: "Anchor", plural: "Anchors", short: "Anchors", kind: "service", Icon: Mic,
    img: "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=940&q=70",
    blurb: "Emcees for sangeet, reception & games" },
  { key: "musician", label: "Musician", plural: "Musicians", short: "Musicians", kind: "service", Icon: Music,
    img: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=940&q=70",
    blurb: "Live bands, DJs, shehnai & quartets" },
];

export const COMBO = { key: "combo_all", label: "All-in-one", plural: "All categories", kind: "combo", Icon: Layers, blurb: "Every category under one plan" };

export const CAT = Object.fromEntries(CATEGORIES.map((c) => [c.key, c]));
export const CAT_LABEL = Object.fromEntries(CATEGORIES.map((c) => [c.key, c.label]));
export const catLabel = (k) => CAT[k]?.label || (k === "combo_all" ? "All-in-one combo" : k === "premium_slot" ? "Premium spotlight" : (k || "").replaceAll("_", " "));
export const catPlural = (k) => CAT[k]?.plural || "Listings";
export const isService = (k) => CAT[k]?.kind === "service";
export const isFood = (k) => CAT[k]?.kind === "food";
export const hasCapacity = (k) => !isService(k);
export const hasCuisine = (k) => !k || CAT[k]?.kind === "venue" || CAT[k]?.kind === "food";

/** Price text for a listing card. */
export function priceOf(v) {
  if (isFood(v.category) && v.price_per_pax) return { amount: v.price_per_pax, unit: "per plate" };
  if (isService(v.category)) return { amount: v.price_per_day || 0, unit: "per event" };
  return { amount: v.price_per_day || 0, unit: "per day" };
}

/** Words the search box cycles through as placeholder hints. */
export const KEYWORD_HINTS = ["palace", "lawn", "mandap", "rooftop", "poolside", "live counters", "candid photography", "sangeet anchor", "live band", "farmhouse", "Jain menu", "floral decor"];
